import React from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";

export default function SupportPage() {
  const phoneNumbers = [
    { number: "+919358807209", whatsapp: true },
    // { number: "+919599166003", whatsapp: true },
    // { number: "+919599166004", whatsapp: true },
  ];

  return (
    <div
      style={{
        margin: "40px auto",
        padding: "24px",
        borderRadius: "12px",
        fontFamily: "sans-serif",
        maxWidth: 600,
      }}
    >
      <div style={{ marginTop: 30, marginBottom: 40, display: "flex", justifyContent: "center" }}>
        <ImageWithBasePath src="assets/logo_support.png" alt="Logo" />
      </div>

      {phoneNumbers.map((item, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "16px 20px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "16px", color: "#333" }}>{item.number}</span>
          <span>
            <a href={`tel:${item.number}`}>
              <i
                className="fas fa-phone"
                style={{
                  color: "#3ab54b",
                  marginRight: "12px",
                  fontSize: "18px",
                }}
              ></i>
            </a>
            {item.whatsapp && (
              <a
                href={`https://wa.me/${item.number}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="fab fa-whatsapp"
                  style={{ color: "#25D366", fontSize: "20px" }}
                ></i>
              </a>
            )}
          </span>
        </div>
      ))}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          padding: "16px 20px",
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "16px", color: "#333" }}>
          support@nssofttech.com
        </span>
        <span>
          <Link href={`mailto: nssofttech77@gmail.com`}>
            <i
              className="fas fa-envelope"
              style={{
                color: "#3ab54b",
                marginRight: "12px",
                fontSize: "18px",
              }}
            ></i>
          </Link>
        </span>
      </div>
    </div>
  );
}
